export interface ParsedGooglePlaceAddress {
  /** 街道行（street_number + route，或 place.name） */
  address: string
  city: string
  /** 省短码，如 ON / BC */
  province: string
  postcode: string
  /** 提交用完整一行：Street, City, PROVINCE POSTAL */
  serviceAddress: string
}

function componentByType(
  components: google.maps.GeocoderAddressComponent[] | undefined,
  type: string,
): google.maps.GeocoderAddressComponent | undefined {
  return components?.find((c) => c.types.includes(type))
}

/** 与 Rapidi composeInput setPlace 对齐：按 address_components 拆分 */
export function parseGooglePlaceAddress(
  place: google.maps.places.PlaceResult | null | undefined,
): ParsedGooglePlaceAddress | null {
  if (!place?.geometry) return null

  const components = place.address_components
  const streetNumber = componentByType(components, 'street_number')?.long_name?.trim() ?? ''
  const route = componentByType(components, 'route')?.long_name?.trim() ?? ''
  const streetFromParts = [streetNumber, route].filter(Boolean).join(' ').trim()
  const address = streetFromParts || (place.name ?? '').trim()

  const city =
    componentByType(components, 'locality')?.long_name?.trim() ||
    componentByType(components, 'sublocality')?.long_name?.trim() ||
    componentByType(components, 'administrative_area_level_3')?.long_name?.trim() ||
    ''

  const province =
    componentByType(components, 'administrative_area_level_1')?.short_name?.trim() || ''

  const postcode =
    componentByType(components, 'postal_code')?.long_name?.trim() ||
    componentByType(components, 'postal_code_prefix')?.long_name?.trim() ||
    ''

  const provincePost = [province, postcode].filter(Boolean).join(' ').trim()
  const tail = [city, provincePost].filter(Boolean).join(', ').trim()
  const serviceAddress = [address, tail].filter(Boolean).join(', ').trim()

  if (!serviceAddress) return null

  return { address, city, province, postcode, serviceAddress }
}
